const equipmentmanufacturers = {
	title: "Equipment Manufacturers",
	stitle: "Equipment Manufacturer",
	new_title: "New Equipment Manufacturer",
	edit_title: "Edit Equipment Manufacturer: {name}",
	list_title: "List of Equipment Manufacturers",
	list_subtitle: "Manage equipment manufacturers",
	id: "ID",
	name: "Name",
	status: "Status",
	reference_id: "Reference ID",
};
export default equipmentmanufacturers;